import { Component, OnInit, Input, inject } from '@angular/core';
import { ClientStats } from 'app/core/models/client-stats.model';
import { Client } from 'app/core/models/client.model';
import { ClientsService } from 'app/core/services/clients.service';
import { DatePipe, DecimalPipe, KeyValuePipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ClientProgramMetrics } from 'app/core/models/client-program-metrics.model';

@Component({
  selector: 'app-client-stats',
  templateUrl: './client-stats.component.html',
  styleUrls: ['./client-stats.component.scss'],
  imports: [MatProgressSpinner, DecimalPipe, DatePipe, KeyValuePipe]
})
export class ClientStatsComponent implements OnInit {
  private clientsService = inject(ClientsService);

  @Input() client: Client;
  clientStats: ClientStats;
  loadingStats: boolean;
  programMetrics: ClientProgramMetrics;
  loadingMetrics: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    this.loadingStats = this.loadingMetrics = true;
    this.clientsService.getStats(this.client.id).subscribe(stats => {
      this.clientStats = stats;
      this.loadingStats = false;
    });
    this.clientsService.getProgramMetrics(this.client.id).subscribe(metrics => {
      this.programMetrics = metrics;
      this.loadingMetrics = false;
    })
  }
}
